import React, { useState } from "react";
import HowItWorks from "./HowItWorks";
import { useNavigate } from "react-router-dom";

const HeroAndHowItWorksSection = () => {
  const [selectionType, setSelectionType] = useState(null); // 'currency' or 'crypto'
  const navigate = useNavigate()
  const handleBack = () => setSelectionType(null);

  const currencyOptions = [
    { code: "EUR", name: "Euro", symbol: "€", bg: "bg-blue-600" },
    { code: "USD", name: "US Dollar", symbol: "$", bg: "bg-green-600" },
    // Add more as needed
  ];

  const cryptoOptions = [
    { code: "BTC", name: "Bitcoin", symbol: "₿", bg: "bg-orange-500" },
    { code: "ETH", name: "Ethereum", symbol: "Ξ", bg: "bg-purple-500" },
    // Add more as needed
  ];

  const handleSelect = (option) => {
    alert(`Selected: ${option.name}`);
    setSelectionType(null);
  }

  return (
    <>
      <div className="relative">
        <section className="py-20 lg:py-32 overflow-hidden">
          {/* Background Image Right Side */}
          <div className="absolute top-0 right-0 hidden lg:block w-1/2 ">
            <img
              src="/images/Background_design.svg"
              alt="Decorative Background"
              className="h-full object-cover"
            />
          </div>

          <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center lg:justify-items-end">
              {/* Left Content */}
              <div className="text-center lg:text-left">
                <h1 className="text-4xl lg:text-5xl font-bold text-[#0B0B0B] mb-6">
                  Instant and Secure Payments Made Easy
                </h1>
                <p className="text-xl text-gray-600 mb-8 lg:max-w-2xl">
                  Lorem Ipsum is simply dummy text of the printing and typesetting
                  industry. Proin vulputate metus in commodo iaculis.
                </p>
                <button className="bg-[#56B22F] text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-[#4a9c28] transition-colors">
                  Start Transaction
                </button>
              </div>

              {/* Right Content - Transaction Panel */}
              <div className="bg-white lg:w-[90%] rounded-2xl shadow-2xl lg:pt-4 relative z-10 overflow-hidden">
                {/* Selection Overlay */}
                {selectionType && (
                  <SelectionOverlay
                    title={selectionType === "currency" ? "Select Currency" : "Select Crypto"}
                    onBack={handleBack}
                    options={selectionType === "currency" ? currencyOptions : cryptoOptions}
                    onSelect={handleSelect}
                  />
                )}

                <div>
                  <h3 className="text-2xl text-center font-semibold mb-4">Buy</h3>
                  <div className="h-1 bg-[#56B22F] w-full mb-4"></div>
                </div>

                <div className="space-y-4 px-7 pb-7">
                  {/* You Send */}
                  <div>
                    <label className="block text-md font-medium text-gray-700 mb-1">You Send</label>
                    <div
                      className="border border-gray-200 rounded-lg p-4 flex items-center justify-between"
                    >
                      <div className="flex items-center space-x-3 cursor-pointer" onClick={() => setSelectionType("currency")}>
                        <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                          <span className="text-white text-sm font-bold">€</span>
                        </div>
                        <div>
                          <div className="text-sm text-gray-500">Euro</div>
                          <div className="font-medium">EUR</div>
                        </div>
                        <svg className="w-4 h-4 ml-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                      </div>
                      <div className="text-right">
                        <input
                          type="text"
                          value="1000"
                          className="bg-transparent text-right text-xl font-semibold border-none outline-none w-20"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Exchange Arrow */}
                  {/* <div className="flex justify-center">
                <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
                  <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                  </svg>
                </div>
              </div> */}

                  {/* You Get */}
                  <div>
                    <label className="block text-md font-medium text-gray-700 mb-1">You Get</label>
                    <div
                      className="border border-gray-200 rounded-lg p-4 flex items-center justify-between"
                    >
                      <div className="flex items-center space-x-3 cursor-pointer" onClick={() => setSelectionType("crypto")}>
                        <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center">
                          <span className="text-white text-xs font-bold">₿</span>
                        </div>
                        <div>
                          <div className="text-sm text-gray-500">Bitcoin</div>
                          <div className="font-medium">BTC</div>
                        </div>
                        <svg className="w-4 h-4 ml-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                      </div>
                      <div className="text-right">
                        <input
                          type="text"
                          value="000000"
                          className="bg-transparent text-right text-xl font-semibold border-none outline-none w-24"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Purchase Details */}
                  <div className="bg-gray-50 rounded-lg p-4">
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-sm text-gray-600">Purchase: 1000EUR</span>
                      <button className="text-sm text-[#56B22F] font-medium">Details</button>
                    </div>
                    <div className="text-sm font-medium">0.0003748 BTC</div>
                  </div>

                  {/* Pay Now Button */}
                  <button onClick={() => navigate("/transaction")} className="w-full bg-[#56B22F] text-white py-3 rounded-lg font-semibold hover:bg-[#4a9c28] transition-colors">
                    Pay Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* How It Works Section */}
        <HowItWorks />
      </div>

    </>
  );
};

export default HeroAndHowItWorksSection;

const SelectionOverlay = ({ title, onBack, options, onSelect }) => {
  return (
    <div className="absolute top-0 left-0 w-full h-full bg-white rounded-2xl z-20 p-6 flex flex-col">
      <button onClick={onBack} className="flex items-center text-[#56B22F] mb-6 text-md font-medium">
        {/* <FaArrowLeft className="mr-2" /> */}
        Back
      </button>
      <h2 className="text-xl font-semibold mb-4">{title}</h2>
      <div className="space-y-3 overflow-auto">
        {options.map((option) => (
          <div
            key={option.code}
            onClick={() => onSelect(option)}
            className="border border-gray-200 rounded-lg p-3 flex items-center justify-between cursor-pointer hover:bg-gray-50"
          >
            <div className="flex items-center space-x-3">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center ${option.bg}`}>
                <span className="text-white font-bold">{option.symbol}</span>
              </div>
              <div>
                <div className="text-sm text-gray-500">{option.name}</div>
                <div className="font-medium">{option.code}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
